export default __webpack_public_path__ + "static/media/CCE_Logo.37536384.jpg";